import { Dispatch } from 'redux';
import { WhatsNewController } from '../controllers/WhatsNewController';
import commonHandler from '../errorHandlers/common-handler';
import { StoreState } from '../store-interfaces';
import CrudActionContainer from './CrudActionContainer';
import { useDispatch } from 'react-redux';

class WhatsNewCRUDActions extends CrudActionContainer {
  constructor() {
    super('WHATS_NEW');
  }

  retrieveAll =
    (pageNumber?: number, pageSize?: number) =>
    async (dispatch: Dispatch<StoreState>) => {
      try {
        const { entities, pagination } = await WhatsNewController.retrieveAll(
          pageNumber,
          pageSize,
        );
        dispatch(this.retrievedAllPagination(entities, pagination));
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
}

export const whatsNewCRUDActions = new WhatsNewCRUDActions();

export const useWhatsNewCRUDActions = () => {
  const dispatch: Dispatch<StoreState> = useDispatch();

  return {
    retrieveAll: (pageNumber?: number, pageSize?: number) =>
      dispatch(whatsNewCRUDActions.retrieveAll(pageNumber, pageSize)),
  };
};
